// Central registry of mountable components.
// Add new components here so they can be referenced by name in ERB.

import CopyText from "./CopyText";

export default {
	CopyText,
};
